import Skeleton from '@/components/ui/Skeleton'

/**
 * Layout-mimicking skeleton for the Album page — header band, year heading,
 * photo grid placeholders.
 */
const AlbumSkeleton = () => {
  return (
    <div className="space-y-10 animate-fade-in">
      {/* Section header — eyebrow, title, dek, action button */}
      <div className="flex items-start justify-between gap-4">
        <div className="min-w-0 flex-1">
          <Skeleton className="h-4 w-32 mb-2" />
          <Skeleton className="h-8 w-2/3 mb-3" />
          <Skeleton shape="text" className="w-4/5" />
        </div>
        <Skeleton className="h-10 w-36 rounded-full shrink-0" />
      </div>

      {/* Year group */}
      <section className="space-y-4">
        <div className="flex items-baseline gap-3 py-2 border-b border-mist/40">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-3 w-16" />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {Array.from({ length: 10 }).map((_, i) => (
            <Skeleton key={i} className="aspect-square rounded-xl" />
          ))}
        </div>
      </section>

      {/* Second year group, slightly fewer */}
      <section className="space-y-4">
        <div className="flex items-baseline gap-3 py-2 border-b border-mist/40">
          <Skeleton className="h-9 w-20" />
          <Skeleton className="h-3 w-16" />
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3">
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={i} className="aspect-square rounded-xl" />
          ))}
        </div>
      </section>
    </div>
  )
}

export default AlbumSkeleton
